export const LOAD_ORDERS_LIST = 'LOAD_ORDERS_LIST';
export const EDIT_ORDER = 'EDIT_ORDER';
export const FINISH_ORDER = 'FINISH_ORDER';
export const REFINISH_ORDER = 'REFINISH_ORDER';
export const CANCEL_ORDER = 'CANCEL_ORDER';
export const RESET_ORDERS = 'RESET_ORDERS';
export const OPEN_CLAIM = 'OPEN_CLAIM';
export const CANCEL_CLAIM = 'CANCEL_CLAIM';
export const SWITCH_NOTE = 'SWITCH_NOTE';
export const RESTART_FINISH_ERROR_ORDERS = 'RESTART_FINISH_ERROR_ORDERS';
